/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

import * as Blockly from 'blockly/core';
import 'blockly/python';
import { AreaService } from '@/services/area.service';
import { getAllowedStatements } from '../block_compatibility_checks';
import { dataset } from '../dataset';
import { CustomFieldDate } from '../../blocklyFieldDate';
import { areaChange } from '../helper_functions';

/*
C-block for droughts
*/

Blockly.Blocks['input_drought_data'] = {
    init: function () {
        var area_dropdown = AreaService.getAreas();
        this.appendDummyInput()
            .appendField('Droughts: ')
            .appendField(new Blockly.FieldDropdown([
                ['Monthly Palmer Drought Severity Index', 'terra_climate'],
            ]), "dropdown")
        this.appendDummyInput('inp')
            .appendField("Area: ", 'area_text')
            .appendField(new Blockly.FieldDropdown(area_dropdown), "area")
            .appendField("From:     ")
            .appendField(new CustomFieldDate(dataset.setFrom(this.getFieldValue('dropdown')),
                function (newValue) { return newValue }, 'true'), 'fd')
            .appendField('      To:    ')
            .appendField(new CustomFieldDate(dataset.getTo(this.getFieldValue('dropdown')),
                function (newValue) { return newValue }, 'true'), 'td');
        this.appendStatementInput("do")
            .setCheck(getAllowedStatements('other_data'))
        this.setInputsInline(false);
        this.setStyle('water');
        this.setTooltip(Blockly.Msg.DROUGHTS_BLOCK_TOOLTIP);
        this.setHelpUrl("");
        this.previous_dataset = 'terra_climate';
        this.previous_area = 'polygon';
        this.setOnChange(() => {
            if (this.getFieldValue('dropdown') !== this.previous_dataset) {
                this.updateShape_();
                var from = this.getField('fd');
                from.setValue(dataset.setFrom(this.getFieldValue('dropdown')));
                var to = this.getField('td');
                to.setValue(dataset.getTo(this.getFieldValue('dropdown')));
                this.previous_dataset = this.getFieldValue('dropdown');
            }

            if (this.getFieldValue('area') !== this.previous_area) {
                if (this.getFieldValue('area') == 'upload_shp') {
                    this.updateAreaParams_('add');
                } else if (this.previous_area == 'upload_shp') {
                    this.updateAreaParams_('remove');
                }
                this.previous_area = this.getFieldValue('area');
            }
        });

        this.areaSubscription = AreaService.areaChange$.subscribe( () => {
            let result = areaChange(this, "inp", "area");
            if(!result) {
                this.areaSubscription.unsubscribe();
            }
        });
    },

    addOneYear: function (fd) {
        var d = new Date(fd);
        var c = new Date(d.getFullYear() + 1, d.getMonth(), d.getDate());
        c = c.toISOString().split('T')[0];
        this.prev_date = c;
        return c;
    },

    updateShape_: function () {
        var from = this.getField('fd');
        from.setValue(dataset.setFrom(this.getFieldValue('dropdown')));
        var to = this.getField('td');
        to.setValue(dataset.getTo(this.getFieldValue('dropdown')));
    },

    updateAreaParams_: function (param) {
        if (param == 'add') {
            this.getInput('area_input').appendField(" Path: ", "path_text")
                .appendField(new Blockly.FieldTextInput("user/shp_name"), "path");
        } else {
            try {
                this.getInput('area_input').removeField("path_text");
                this.getInput('area_input').removeField("path");
            } catch (e) {
                console.log('Input does not exist');
            }
        }
    }
};